module.exports = __webpack_public_path__ + "img/hl7.beccfc18.png";